import { Preferences } from '@capacitor/preferences';
import { Capacitor, registerPlugin } from '@capacitor/core';
import { KeychainAccess, SecureStorage } from '@aparajita/capacitor-secure-storage';
import { STORAGE_KEYS } from '@/shared/constants/app';

const PreferencesPersistence = registerPlugin('PreferencesPersistence');

class StorageService {
  async getItem(key) {
    if (key === STORAGE_KEYS.TOKEN && Capacitor.getPlatform() !== 'web') {
      return SecureStorage.get(key, false, false);
    }

    const { value } = await Preferences.get({ key });
    return value;
  }

  async setItem(key, value) {
    if (key === STORAGE_KEYS.TOKEN && Capacitor.getPlatform() !== 'web') {
      // Keep the JWT local to this device and available only while iOS is unlocked.
      await SecureStorage.set(key, value, false, false, KeychainAccess.whenUnlockedThisDeviceOnly);
      if (Capacitor.getPlatform() === 'android') {
        await PreferencesPersistence.flushSecureStorage();
      }
      return;
    }

    return Preferences.set({ key, value });
  }

  async removeItem(key) {
    if (key === STORAGE_KEYS.TOKEN && Capacitor.getPlatform() !== 'web') {
      await SecureStorage.remove(key, false);
      if (Capacitor.getPlatform() === 'android') {
        await PreferencesPersistence.flushSecureStorage();
      }
      return;
    }

    await Preferences.remove({ key });
    if (Capacitor.getPlatform() === 'android') {
      await PreferencesPersistence.flush();
    }
  }
}

export default new StorageService();
